import React from 'react';
interface TierNoteProps {
  tier: string;
  label: string;
  note: string;
}

/**
 * A design annotation, not a live UI element — it marks which content tier a
 * section of the hub represents so the structure is legible at a glance.
 */
export function TierNote({
  tier,
  label,
  note
}: TierNoteProps) {
  return <p className="mb-6 inline-flex flex-wrap items-center gap-x-3 gap-y-1 border border-dashed border-olive px-4 py-2" data-id="element-294" data-mp="302uk8a99ovhq">
      <span className="label text-olive" data-id="element-295" data-mp="2v6dujbmf692j">
        Tier {tier} · {label}
      </span>
      <span className="text-[12.5px] italic text-muted" data-id="element-296" data-mp="2q4ya9ls2g6l7">{note}</span>
    </p>;
}